import Cookies from "js-cookie";
import { BREAKPOINTS, CLASSES } from "@/scripts/helpers/constants";
import { getDomainName } from "@/scripts/helpers/getUrlParams";

export default () => {
  const { DESKTOP } = BREAKPOINTS;
  const { IS_VISIBLE, IS_ACTIVE, IS_OPEN } = CLASSES;

  function cookiePopup() {
    // Cookies
    const cookieAccepted = "COOKIES_AGREEMENT_UPDATED";
    const cookieRejected = "COOKIES_REJECTED_UPDATED";
    const isCookiesAccepted = Cookies.get(cookieAccepted);
    const isCookiesRejected = Cookies.get(cookieRejected);

    const domain = getDomainName();

    // UI Elements
    const popup = $(".popup-cookie");
    const popupText = $(".popup-text");
    const readMore = $(".popup-readmore--more");
    const readLess = $(".popup-readmore--less");
    const pageContainer = $(".page-section__inner").outerWidth();
    const header = $(".page-header, .g-header");
    const textWrapper = $(".popup-cookie__column--description");
    const bannerHeader = $(".banner-header");

    // Triggers
    const accept = $(".js-popup-accept");
    const close = $(".js-popup-close");

    function accepted() {
      Cookies.set(cookieAccepted, "true", { expires: 30, domain: domain });
      popup.removeClass(IS_VISIBLE).removeAttr("style");
    }

    function autoConfirmed() {
      Cookies.set(cookieRejected, "true", { expires: 0.02, domain: domain });
      popup.removeClass(IS_VISIBLE).removeAttr("style");
    }

    function detectContainer() {
      if (pageContainer === DESKTOP) {
        popup.addClass("popup-cookie--old-container");
      }
    }

    function topPopupHack() {
      const pageHeaderHeight = header.outerHeight();
      const smartappBanner = $(".smartbanner");
      const smartappBannerHeight = smartappBanner.outerHeight();
      const bannerHeaderHeight = bannerHeader.outerHeight();
      const scroll = $(window).scrollTop();
      let offset;

      if (
        !isCookiesAccepted &&
        !isCookiesRejected &&
        window.cookiesPrivacyData.showPopUp &&
        popup.hasClass(IS_VISIBLE)
      ) {
        offset = header.outerHeight();

        if (bannerHeader.length) {
          offset = offset + bannerHeaderHeight;
        }

        if (smartappBanner.length) {
          offset = offset + smartappBannerHeight;
        }

        if ($(window).width() < DESKTOP) {
          if (scroll > 0) {
            popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
          } else if (bannerHeader.length || smartappBanner.length) {
            popup.css("transform", `translateY(${offset}px)`);
            if (bannerHeader.hasClass(CLASSES.IS_HIDDEN)) {
              popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
            }

            if (!$(".smartbanner-show").length) {
              popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
            }
          } else {
            popup.css("transform", `translateY(${pageHeaderHeight}px)`);
          }

          bannerHeader.find(".banner-close").click(() => {
            popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
          });

          $(".smartbanner-close").click(() => {
            popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
          });
        } else {
          if (scroll > 0) {
            popup.css("transform", `translateY(${pageHeaderHeight}px)`);
          } else if (bannerHeader.length) {
            popup.css("transform", `translateY(${offset}px)`);

            if (bannerHeader.hasClass(CLASSES.IS_HIDDEN)) {
              popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
            }
          } else {
            popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
          }

          bannerHeader.find(".banner-close").click(() => {
            popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
          });
        }
      }
    }

    // setTimeout(() => {
    //   topPopupHack();
    // }, 1);

    // $(document).scroll(() => {
    //   topPopupHack();
    // });

    // header.change(() => {
    //   topPopupHack();
    // });

    readMore.click(() => {
      popupText.addClass(IS_VISIBLE);
      textWrapper.addClass(IS_OPEN);
      readMore.hide();
      readLess.show();
    });

    readLess.click(() => {
      popupText.removeClass(IS_VISIBLE);
      textWrapper.removeClass(IS_OPEN);
      readMore.show();
      readLess.hide();
    });

    if (
      !isCookiesAccepted &&
      !isCookiesRejected &&
      window.cookiesPrivacyData.showPopUp
    ) {
      detectContainer();
      popup.addClass(IS_VISIBLE);
      $(window).resize(() => {
        detectContainer();
      });
    }

    accept.click(() => {
      accepted();
      acceptEvent();
    });

    close.click(() => {
      autoConfirmed();
    });
  }

  $(document).ready(() => {
    if ($(".popup-cookie").length) {
      cookiePopup();
    }
  });
};
